import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-2 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-accent-400 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800" : ""}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-600" />}
          </span>
        );
      })}
    </nav>
  );
}